import { render } from "./WhiteLogoIcon.vue?vue&type=template&id=8e790c9a&scoped=true"
const script = {}

import "./WhiteLogoIcon.vue?vue&type=style&index=0&id=8e790c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e790c9a"]])

export default __exports__